var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconsettingscommunity = function SvgIconsettingscommunity(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Settings/icon.settings.organization") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Settings/icon.settings.organization",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,1 C18.2393458,1 23.5,6.26065419 23.5,12.75 C23.5,19.2393458 18.2393458,24.5 11.75,24.5 C5.26065419,24.5 0,19.2393458 0,12.75 C0,6.26065419 5.26065419,1 11.75,1 Z",
    id: "Path_508",
    fill: "#D9E8E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/care_group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.583,0 C17.9801143,0 23.166,5.18588574 23.166,11.583 C23.166,17.9801143 17.9801143,23.166 11.583,23.166 C5.18588574,23.166 0,17.9801143 0,11.583 C0,5.18588574 5.18588574,0 11.583,0 Z",
    id: "Path_510"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15.000000, 12.000000) scale(-1, 1) translate(-15.000000, -12.000000) translate(11.500000, 5.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 7,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13 L0,0.318181818 C-2.15203466e-17,0.142454852 0.142454852,8.77916712e-17 0.318181818,0 L6.68181818,0 C6.85754515,2.32306313e-17 7,0.142454852 7,0.318181818 L7,4.02380952 L7,4.02380952",
    id: "Path-2",
    stroke: "#09BE86",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.272727, 1.238095)",
    fill: "#09BE86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1.90909091,
    height: 1.85714286,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 2.54545455,
    y: 0,
    width: 1.90909091,
    height: 1.85714286,
    rx: 0.636363636
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(4.500000, 9.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#09BE86",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 9,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2,9.375 L5.2,7.19318182 C5.2,7.01745485 5.34245485,6.875 5.51818182,6.875 L7.48181818,6.875 C7.65754515,6.875 7.8,7.01745485 7.8,7.19318182 L7.8,9.375 L7.8,9.375",
    id: "Path-6",
    fill: "#09BE86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.950000, 1.875000)",
    fill: "#09BE86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 0,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 3.575,
    y: 0,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 7.15,
    y: 0,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 2.5,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 3.575,
    y: 2.5,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 7.15,
    y: 2.5,
    width: 1.95,
    height: 1.875,
    rx: 0.636363636
  }))))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconsettingscommunity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.settings.community.048632c2f26ca3242c60aba6d72b9d1d.svg";